module.exports = __webpack_public_path__ + "static/media/ayudaVerde.4ca06850.png";